module.exports = __webpack_public_path__ + "static/img/localhost.9d16652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/localhost.png
// module id = 203
// module chunks = 10